import {
  FETCH_SPORT_VARIANTS,
  UPDATE_SPORT_VARIANT,
  CREATE_SPORT_VARIANT,
  DELETE_SPORT_VARIANT
} from "../../store/constants/hwk";

export function fetchSportVariants() {
  return {
    type: FETCH_SPORT_VARIANTS
  };
}

export function updateSportVariant(payload = {}) {
  return {
    type: UPDATE_SPORT_VARIANT,
    payload
  };
}

export function createSportVariant(payload = {}) {
  return {
    type: CREATE_SPORT_VARIANT,
    payload
  };
}

export function deleteSportVariant(payload = {}) {
  return {
    type: DELETE_SPORT_VARIANT,
    payload
  };
}
